import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

interface KistillDurationPickerProps {
  value: string | null
  onChange: (newTime: string | null) => void
  error: boolean
  setError: (error: boolean) => void
  label?: string
  disabled?: boolean
}

export const KistillDurationPicker: React.FC<KistillDurationPickerProps> = ({
  value = null,
  onChange,
  error,
  setError,
  label = 'Duration',
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    if (value !== null) {
      // Handle both HH:MM:SS and HH:MM:SS.0000000 formats
      const timePart = value.includes('.') ? value.split('.')[0] : value
      setInputValue(timePart)
    } else {
      setInputValue('')
    }
  }, [value])

  const validateDuration = (duration: string): boolean => {
    return /^\d{1,5}:[0-5][0-9]:[0-5][0-9]$/.test(duration)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value
    setInputValue(newValue)

    if (newValue === '') {
      setError(false)
      onChange(null)
    } else if (validateDuration(newValue)) {
      setError(false)
      onChange(newValue)
    } else {
      setError(true)
    }
  }

  const handleBlur = () => {
    if (inputValue === '') {
      setError(false)
      onChange(null)
    } else if (!validateDuration(inputValue)) {
      setError(true)
      onChange(null)
    } else {
      setError(false)
      onChange(inputValue)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TextField
        label={label}
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        error={error}
        helperText={error ? 'Ógilt format. Vinsamlegast notaðu HH:MM:SS' : ''}
        disabled={disabled}
        placeholder='00:00:00'
        fullWidth
        InputLabelProps={{
          shrink: true,
        }}
      />
    </LocalizationProvider>
  )
}
